const contact = {
  email: "carson@carsongodwin.com",
  linkedin: "https://www.linkedin.com/in/carson-godwin/",
  github: "https://github.com/CarsonGodwin",
  site: "carsongodwin.com",
  location: "New York, NY",
  updated: "October 2026"
};

export default contact;
